import { Reducer } from 'redux'
import { IAction, ICarrier, ICarrierState } from 'apps/fleet-planner/types'
import { FETCH_CARRIERS_ACTION_TYPES } from 'apps/fleet-planner/utils/actions/carriers'

const {
  FETCH_CARRIERS_FAILURE,
  FETCH_CARRIERS_REQUEST,
  FETCH_CARRIERS_SUCCESS,
} = FETCH_CARRIERS_ACTION_TYPES

const defaultState: ICarrierState = {
  fetching: false,
  carriers: [],
  carriersSelect: [],
}

interface ISuccessAction extends IAction {
  payload: {
    motorCarriers: ICarrier[]
  }
}

type CarriersAction = IAction | ISuccessAction

const carriersReducer: Reducer<ICarrierState, CarriersAction> = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_CARRIERS_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: undefined,
      }
    }

    case FETCH_CARRIERS_SUCCESS: {
      const {
        payload: { motorCarriers = [] },
      } = (action || {}) as ISuccessAction
      return {
        ...state,
        carriers: motorCarriers,
        carriersSelect: motorCarriers.map(({ id, legalName, name }) => ({
          label: legalName || name,
          value: id,
        })),
        fetching: false,
      }
    }

    case FETCH_CARRIERS_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    }

    default:
      return state
  }
}

export default carriersReducer
